import { auth } from "api/firebase";
import { FileProvider } from "@evennt-tech/api-v2-core";

export const convertFileUrl = async (
  fileUrl: string,
  provider?: FileProvider
) => {
  if (!provider || provider !== FileProvider.AWS) {
    return fileUrl;
  }
  const token = await auth.currentUser?.getIdToken();

  if (!token) {
    return fileUrl;
  }

  return `${fileUrl}?token=${token}`;
};
